<script setup>
import { defineProps } from 'vue';

const props = defineProps({
  title: {
    type: String,
    required: true,
  },
  link: {
    type: String,
    required: false,
  },
  type: {
    type: String,
    default: 'button', // Por defecto, evita el envío del formulario
    validator: (value) => ['button', 'submit', 'reset'].includes(value),
  },
  disabled: {
    type: Boolean,
    default: false,
  },
});
</script>

<template>
  <router-link :to="link" v-if="link" class="inline-flex items-center bg-emerald-500 hover:bg-emerald-700 text-black font-bold py-2 px-4 rounded">
    {{ title }}
  </router-link>
  <button
      v-else
      :type="props.type"
      :class="[
              ' text-black font-bold py-2 px-4 rounded transition-colors',
              disabled
                ? 'bg-gray-400 text-gray-200 cursor-not-allowed dark:bg-gray-600 dark:text-gray-400'
                : 'bg-emerald-500 hover:bg-emerald-700'
            ]"
      role="button"
  >
    {{ props.title }}
  </button>
</template>
